export default __webpack_public_path__ + "static/media/edit.ca5c6b4c.svg";